// const OtherInfo = () => {
//   return (
//     <div className="card">
//       <div className="step-title">OtherInfo</div>
//       <input
//         type="text"
//         placeholder="Favorite Language"
//       />
//       <input
//         type="text"
//         placeholder="Joined At"
//       />
//       <input
//         type="Tshirt Size"
//         placeholder="Zipcode"
//       />
//       <input
//         type="Tshirt Color"
//         placeholder="Zipcode"
//       />

//       <button>
//         Submit
//       </button>
//       <br />
//       <button>
//         Previous
//       </button>
//     </div>
//   );
// };

// export default OtherInfo;
import { motion } from "framer-motion";
import { useState } from "react";
import { makeStyles, TextFeild, Button, TextField } from "@material-ui/core";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";

import CloseIcon from "@mui/icons-material/Close";
import "react-toastify/dist/ReactToastify.css";
// const useStyles = makeStyles((theme) => ({

// }));
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(2),
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff"
    },

    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "300px"
    },
    "& .MuiFormLabel-root": {
      color: "#eddbca", // or black
      outline: "red",
      fontSize: "13px",
      input: {
        color: "white"
      }
    },
    "& .MuiButtonBase-root": {
      margin: theme.spacing(2)
    },
    "& .MuiInputBase-root": {
      color: "#eddbca",
      fontSize: "14px"
    },
    input: {
      backgroundColor: "white",
      color: "white"
    },
    TextField: {
      color: "white"
    }
  }
}));
const Other = ({ formData, setFormData, page, setPage, x, setX }) => {
  const classes = useStyles();
  const [test, setTest] = useState([]);
  const [open, setOpen] = useState(true);
  const [clicked, setClicked] = useState(false);
  const [showSuccess, setShowSuccess] = useState("");

  // const notify = () =>
  // toast.success("Created account successfully.", {
  //   position: toast.POSITION.TOP_CENTER,
  //   autoClose: 3000
  // });

  const handleClick = (e) => {
    e.preventDefault();
    const dataFor = [
      {
        Name: formData.name,
        Email: formData.email,
        TelegramUsername: formData.telegramUsername,
        PhoneNumber: formData.phoneNumber,
        Instagram: formData.instagram,
        Birthday: formData.birthday,

        Joined: formData.joined,

        ShortBio: formData.shortBio,
        ExpectedGraduationDate: formData.expectedGraduationDate,
        University: formData.university,
        Department: formData.department,
        Leetcode: formData.leetcode,
        Hackerrank: formData.hackerrank,
        Codeforces: formData.codeforces,
        Github: formData.github,
        FavoriteLanguage: formData.favoriteLanguage,
        TshirtColor: formData.tshirtColor,
        TshirtSize: formData.tshirtSize
      }
    ];

    try {
      // const dataFor = [
      //   {
      //     Name: data.name,
      //     Email: data.email,
      //     TelegramUsername: data.telegramUsername,
      //     PhoneNumber: data.phoneNumber,
      //     Instagram: data.instagram,
      //     Birthday: data.birthday,

      //     Joined: data.joined,

      //     ShortBio: data.shortBio,
      //     ExpectedGraduationDate: data.expectedGraduationDate,
      //     University: data.university,
      //     Department: data.department,
      //     Leetcode: data.leetcode,
      //     Hackerrank: data.hackerrank,
      //     Codeforces: data.codeforces,
      //     Github: data.github,
      //     FavoriteLanguage: data.favoriteLanguage,
      //     TshirtColor: data.tshirtColor,
      //     TshirtSize: data.tshirtSize
      //   }
      // ];
      setClicked(true);
      const res = fetch("https://app.sheetlabs.com/KINF/a2svinfo", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(dataFor)
      }).then((response) => {
        if (response.ok) {
          setTimeout(() => {
            setShowSuccess(true);
          }, 2000);
        }
      });
    } catch (err) {
      console.log(err);
    }
  };
  const areTruthy = Object.values(test).every((value) => value);

  console.log(test);

  return (
    <motion.div
      initial={{ x: x }}
      transition={{ duration: 1 }}
      animate={{ x: 0 }}
      className="card"
    >
      <form className={classes.root}>
        <h4 style={{ marginTop: 10, color: "white" }}>
          👉🏽 Other Info - 5/5❗️
        </h4>
        <TextField
          variant="outlined"
          type="text"
          placeholder="Favorite Language"
          value={formData.favoriteLanguage}
          onChange={(e) =>
            setFormData({ ...formData, favoriteLanguage: e.target.value })
          }
        />

        <TextField
          type="text"
          placeholder="Joined at"
          variant="outlined"
          value={formData.joined}
          onChange={(e) => setFormData({ ...formData, joined: e.target.value })}
        />

        <TextField
          type="text"
          variant="outlined"
          placeholder="Tshirt Size"
          value={formData.tshirtSize}
          onChange={(e) =>
            setFormData({ ...formData, tshirtSize: e.target.value })
          }
        />
        <TextField
          type="text"
          variant="outlined"
          placeholder="Tshirt Color"
          value={formData.tshirtColor}
          onChange={(e) =>
            setFormData({ ...formData, tshirtColor: e.target.value })
          }
        />
      </form>
      <br />
      <Button
        variant="contained"
        color="primary"
        style={{ marginBottom: 10, marginRight: 10 }}
        onClick={() => {
          setPage(page - 1);
          setX(-1000);
        }}
      >
        Previous
      </Button>
      <Button
        variant="contained"
        color="primary"
        style={{ marginBottom: 10 }}
        onClick={handleClick}
      >
        Register
      </Button>
      {!showSuccess && clicked ? (
        <div>
          <Backdrop className={classes.backdrop} open>
            {" "}
            <CircularProgress color="inherit" />{" "}
          </Backdrop>
        </div>
      ) : (
        ""
      )}

      {showSuccess && (
        <Box sx={{ width: "100%" }}>
          <Collapse in={open}>
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{ mb: 2 }}
            >
              ✅ {formData.name} You have registered successfully! check your profile by getting to
              <Link to="/profile">
                <b>
                  {" "}
                  {"-"} Profile page [✅]
                </b>
              </Link>
            </Alert>
          </Collapse>
        </Box>
      )}

      {/* // ) : (
      //   <Alert variant="filled" severity="error">
      //     Error while creating an account check the feilds or internet
      //     connection
      //   </Alert> */}
      {/* )} */}
    </motion.div>
  );
};

export default Other;
